import { useLazyQuery } from "@apollo/client";
import { useState } from "react";
import { useSelector } from "react-redux";
import Button from "../../Components/Button/Button";
import Input from "../../Components/Input/Input";
import PortalFooter from "../../Components/Reactportal/PortalFooter";
import Reactportal from "../../Components/Reactportal/Reactportal";
import { ErrorToast, SuccessToast } from "../../Components/ToastComponent/RectHotToast";
import AddLicenseRights from "./AddLicenseRights/AddLicenseRights";

const { gql, useMutation } = require("@apollo/client");

const GetLicenseePageRightsByLicensee_ID = gql`
  query GetLicenseePageRightsByLicensee_Master_ID($licenseeMasterId: ID!) {
    GetLicenseePageRightsByLicensee_Master_ID(Licensee_Master_ID: $licenseeMasterId) {
      _id
      Unique_Id
      Page_Name
      Licensee_No
      Licensee_Master_ID
      Page_Master_ID
      Page_Access
      createdAt
      updatedAt
    }
  }
`;

export const GetLicensee_With_Search = gql`
  query AllLicensee($keyword: String) {
    GetLicensee_With_Search(keyword: $keyword) {
      _id
      Unique_Id
      Name
      Search_Value
      City
      Mobile_Number
      GST_Number
      PAN_Number
      TAN_Number
    }
  }
`;

export const GetLicensee_With_Search_value = gql`
query GetLicensee_With_Search($keyword: String) {
  GetLicensee_With_Search(keyword: $keyword) {
    _id
    Name
    Unique_Id
    Search_Value
  }
}
`
const EditRights = gql`
  mutation EditLicenseePageRightsByArrayOfID($userInput: [EditPageRights]) {
    editLicenseePageRightsByArrayOfID(userInput: $userInput) {
      message
    }
  }
`;

export const LicenseRigths = ({ParentPortalCloseFunction}) => {
  const [toggle, settoggle] = useState(true);
  const [licenseeMasterId, setlicenseeMasterId] = useState("");
  const [allData, setAllData] = useState([]);
  const TypeOfPortal = "Licensee Page Rights";
  const [EditLicenseeRights, { loading: EditLicenseeRightsLoading }] = useMutation(EditRights);
  const LicenseeRightsData = useSelector((store: any) => store.LicenseeRightsData);
  const LicenseePageRightsLoadingState = EditLicenseeRightsLoading ? true : false;
  const [searchPage, setPageName] = useState("");
  const FormDataFromRedux = useSelector((store: any) => store?.FormDataReducer);

  const [LicenseeDatafetch] = useLazyQuery(GetLicenseePageRightsByLicensee_ID, {
    fetchPolicy: "network-only",
  });

  const Closeformfunction = () => {
    settoggle(false);
    ParentPortalCloseFunction()
  };

  const handleChange = (e) => {
    setlicenseeMasterId(e.target.value);
  };

  const handleGo = () => {
    LicenseeDatafetch({
      variables: {
        licenseeMasterId: FormDataFromRedux?.MasterData["Licensee_Page_Rights"]["Licensee_Rights"]._id,
      },
    })
      .then((res) => setAllData(res.data.GetLicenseePageRightsByLicensee_Master_ID))
      .catch((err) => console.log(err));
  };
  const SaveAndClose = () => {
    submit();
    Closeformfunction();
  };
  const submit = async () => {
    const LicenseerightsdataArray = LicenseeRightsData?.Licenseerightsdata;
    EditLicenseeRights({
      variables: {
        userInput: LicenseerightsdataArray,
      },
    })
      .then((res) => {
        SuccessToast(res.data.editLicenseePageRightsByArrayOfID.message);
        handleGo();
      })
      .catch((err) => {
        settoggle(toggle);
        ErrorToast(err.message);
      });
  };

  return (
    <div className="RightsContainer">
      <Reactportal open={toggle} onClose={Closeformfunction} TypeOfPortal={TypeOfPortal} UserRightsPortal={true}>
        <div className="UserRightsContainer">
          <div className="RightsHeader">
            <div className="RightsHeaderDiv">
              <Input
                EMTQuery=""
                checked={""}
                InputConfig={{
                  masterName: "Licensee",
                }}
                type="InputDropForQuery"
                name="Licensee_Rights"

                handleBlur={() => { }}
                handleInputChange={(e) => {
                  handleChange(e);
                }}
                label={"Licensee"}
                modalform={true}
                TypeOfPortal={""}
                Section_Type={""}
                value={licenseeMasterId}
                className={""}
                touched={""}
                error={""}
                max={Infinity}
                JurnalDropdown={""}
                disabled={""}


                transactions={""}
                PaymentProcess={""}
                notSearchable={""}

                formkey="Licensee_Page_Rights"
              />
              <Button name="gobutton" text="GO" action={handleGo} type={""} children={""} disabled={""}></Button>
            </div>

            <div className="RightsHeaderDiv">
              <Input
                EMTQuery=""
                checked={""}
                InputConfig=""
                type="text"
                name="Page"

                handleBlur={() => { }}
                handleInputChange={(e) => {
                  setPageName(e.target.value);
                }}
                label={"Search Page"}
                modalform={true}
                TypeOfPortal={""}
                Section_Type={""}
                value={searchPage}
                className={""}
                touched={""}
                error={""}
                max={Infinity}
                JurnalDropdown={""}


                transactions={""}
                PaymentProcess={""}
                notSearchable={""}

                disabled={!allData.length}
              />
            </div>
          </div>
        </div>
        <div className="TableContainer">
          <AddLicenseRights searchPage={searchPage} data={allData} handleRights={(data: any) => { }} />
        </div>
        <PortalFooter
          renderContent={() => <></>}
          disabled={false}
          loadingState={LicenseePageRightsLoadingState}
          submitform={submit}
          SaveAndClose={SaveAndClose}
          handleformclose={() => {
            Closeformfunction();
            settoggle(!toggle);
          }}
          submitType={"Submit"}
          UserRightsPortal={true}
        />
      </Reactportal>
    </div>
  );
};
